import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { PusherProvider } from '@harelpls/use-pusher';
import MetaTags from 'react-meta-tags';
import MessengerSideBar from './sidebar';
import MessengerContainer from './content';

import './messenger.scss';
import './messenger-mobile.scss';
// import useDidMountEffect from '../../utils/useDidMountEffect';
import { setMessages } from '../../../redux/actions';
import { connect, useDispatch } from 'react-redux';
import { setStashSort, setStashType, setFilterToDate } from '../../../redux/actions/stash';

const Messenger = ({ setMessages }) => {
    const dispatch = useDispatch();
    const token = localStorage.getItem('loggedin_access_token');

    const config = {
        clientKey: process.env.MIX_PUSHER_APP_KEY,
        cluster: process.env.MIX_PUSHER_APP_CLUSTER,
        encrypted: true,
        // required for private/presence channels
        // also sends auth headers to trigger endpoint
        authEndpoint: '/broadcasting/auth',
        auth: {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${token}`,
            },
        },
    };

    /* active set is just ID of chatbox to render in messenger container. */
    const [active, setActive] = useState(null);
    const [activeConv, setActiveConv] = useState(null);
    const [latestMsg, setLatestMsg] = useState(null);
    const [msgModalIsOpen, setMsgModalIsOpen] = useState(false);
    const [refreshConvList, setRefreshConvList] = useState(false);
    const [showMobileChat, setShowMobileChat] = useState(false);
    const [user, setUser] = useState({ id: 0, login: '', email: '' });

    const location = useLocation();

    useMemo(() => {
        const userData = JSON.parse(localStorage.getItem('user'));
        if (!userData) {
            window.location = '/login';
        }
        setUser(userData);
    }, [JSON.stringify(user)]);

    const clearChatWindowOnFirstLoad = () => {
        //clear messages when navigating to the messenger page
        setMessages([]);
    }

    useEffect(() => {
        document.body.classList.add('o-hidden');
        document.documentElement.classList.add('o-hidden');


        const handleActiveConv = (conv) => {
            setActiveConv(conv);
        };

        window.addEventListener('sidebar/setactive', handleActiveConv);

        return () => {
            dispatch(setStashType('all'));
            dispatch(setStashSort('DESC'));
            dispatch(setFilterToDate(''));
            document.body.classList.remove('o-hidden');
            document.documentElement.classList.remove('o-hidden');    
            clearChatWindowOnFirstLoad();
            window.removeEventListener('sidebar/setactive', handleActiveConv);
        };
    }, []);

    return (
        <div
            className={`messenger-container${showMobileChat ? ' show-chat-mobile' : ''} messenger-container-${user.role}`}
        >
            <MetaTags>
                <title>Messages &#8211; Best way to make money as an influencer for your exclusive content</title>
                <meta
                    name="description"
                    content="Privaposts is a social media platform that lets influencers make money from their followers by keeping exclusive content hidden until a monthly subscription price has been paid."
                />
            </MetaTags>

            <MessengerSideBar
                loginUser={user}
                setActive={setActive}
                active={active}
                latestMsg={latestMsg}
                activeConv={activeConv}
                setActiveConv={setActiveConv}
                setMsgModalIsOpen={setMsgModalIsOpen}
                setRefreshConvList={setRefreshConvList}
                refreshConvList={refreshConvList}
                setShowMobileChat={setShowMobileChat}
            />

            <PusherProvider {...config}>
                <MessengerContainer
                    active={active}
                    setActive={setActive}
                    latestMsg={latestMsg}
                    setLatestMsg={setLatestMsg}
                    msgModalIsOpen={msgModalIsOpen}
                    setMsgModalIsOpen={setMsgModalIsOpen}
                    refreshConvList={refreshConvList}
                    setRefreshConvList={setRefreshConvList}
                    setShowMobileChat={setShowMobileChat}
                />
            </PusherProvider>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        messages: state.message.messages
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setMessages: (payload) => dispatch(setMessages(payload))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(Messenger));
